import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Create } from 'components/detail'
import { SimpleFormNoInit } from 'components/form'
import { TextInput, DatetimeInput, SelectInput } from 'components/input'
import {
  InputOptions
} from 'util/constants'

import { maxLength } from 'components/form';

import * as urls from './urls'
import * as utils from './utils'

class PopupNotificationCreateBase extends Component {
  handleSubmit = (props, basePath) => (record) => {
    const formDataRecord = new FormData();
    formDataRecord.append('notification_type', record['notification_type']);
    formDataRecord.append('description', record['description']);
    formDataRecord.append('en_title', record['en_title']);
    formDataRecord.append('local_title', record['local_title']);
    formDataRecord.append('en_body', record['en_body']);
    formDataRecord.append('local_body', record['local_body']);
    formDataRecord.append('en_hyperlink_name', record['en_hyperlink_name']);
    formDataRecord.append('local_hyperlink_name', record['local_hyperlink_name']);
    formDataRecord.append('hyperlink_link', record['hyperlink_link']);
    formDataRecord.append('effective_time', record['effective_time']);
    formDataRecord.append('valid', record['valid']);
    props.crudCreate(props.resource, formDataRecord, props.createBackendPath, basePath);
  };

  render() {
    return (
      <Create createBackendPath={urls.popupNotificationCreateBackendPath}
              handleSubmit={this.handleSubmit} {...this.props}>
        <SimpleFormNoInit>
          <SelectInput
            source='notification_type'
            label='Notification type'
            isRequired={true}
            choices={utils.POPUP_NOTIFICATION_TYPE_CHOICES}
            defaultValue={utils.POPUP_NOTIFICATION_TERM_CONDITIONS}
          />
          <TextInput source='description' label='Description' validators={[maxLength(50)]} isRequired={true} options={InputOptions} />
          <TextInput source='en_title' label='EN Title' validators={[maxLength(50)]} isRequired={true} options={InputOptions} />
          <TextInput source='local_title' label='TH Title' validators={[maxLength(50)]} isRequired={true} options={InputOptions} />
          <TextInput source='en_body' label='EN Body' validators={[maxLength(255)]} isRequired={true} options={InputOptions} />
          <TextInput source='local_body' label='TH Body' validators={[maxLength(255)]} isRequired={true} options={InputOptions} />
          <TextInput source='en_hyperlink_name' label='EN Hyperlinks Name' validators={[maxLength(50)]} isRequired={true} options={InputOptions} />
          <TextInput source='local_hyperlink_name' label='TH Hyperlinks Name' validators={[maxLength(50)]} isRequired={true} options={InputOptions} />
          <TextInput source='hyperlink_link' label='Hyperlinks Link' isRequired={true} options={InputOptions} />
          <DatetimeInput source='effective_time' label='Effective Date' isRequired={true} options={InputOptions} optionsTime={InputOptions}/>
          <SelectInput
            source='valid'
            label='Status'
            choices={utils.POPUP_STATUS_DISPLAY_CHOICES}
            options={InputOptions}
            defaultValue={false}
            optionValue={'enabled'}
          />
        </SimpleFormNoInit>
      </Create>
    )
  }
}

export const PopupNotificationCreate = connect()(PopupNotificationCreateBase);


// WEBPACK FOOTER //
// ./src/routes/notification/PopupNotificationCreate.js